import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function ova(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@ova/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ova/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ova/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@ova/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ova/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ova/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}